import { Cookies } from 'react-cookie';

import axiosInterceptor from 'api/interceptor/axiosClient';

export interface addOwnerToClientProps {
  clientId?: number;
  ownerId: string;
}

export const addOwnerToClient = async ({ clientId, ownerId }: addOwnerToClientProps) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.post(
    `company_object/${clientId}/add_tech`,
    {
      ownerId: ownerId,
    },
    {
      headers: {
        Authorization: token,
      },
    },
  );

  return data.data as any;
};
